import { render, staticRenderFns } from "./overflow.vue?vue&type=template&id=7b4e2d6a&"
import script from "./overflow.vue?vue&type=script&lang=js&"
export * from "./overflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports